import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'outline';
  className?: string;
  fullWidth?: boolean;
  showIcon?: boolean;
}
export function CTAButton({
  children,
  href,
  onClick,
  variant = 'primary',
  className = '',
  fullWidth = false,
  showIcon = true
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg rounded-full py-4 px-8 text-lg';
  const variants = {
    primary: 'bg-purple-600 text-white hover:bg-purple-700 shadow-purple-200',
    secondary: 'bg-yellow-400 text-purple-900 hover:bg-yellow-300 shadow-yellow-100',
    outline: 'border-2 border-purple-600 text-purple-600 hover:bg-purple-50'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClassName = `${baseStyles} ${variants[variant]} ${widthClass} ${className}`;
  const content = <>
      <span data-id="element-168">{children}</span>
      {showIcon && <ArrowRight className="ml-2 w-5 h-5" data-id="element-169" />}
    </>;
  if (href) {
    return <a href={href} className={combinedClassName} onClick={onClick} data-id="element-170">
        {content}
      </a>;
  }
  return <button onClick={onClick} className={combinedClassName} data-id="element-171">
      {content}
    </button>;
}